import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","gap":"1em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Color = _resolveComponent("Color")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!
  const _component_EffectBlock = _resolveComponent("EffectBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Fieldset, { label: "背景色" }, {
      default: _withCtx(() => [
        _createVNode(_component_Space, {
          vertical: "",
          full: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Color, {
              modelValue: _ctx.conf.backgroundColor,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.conf.backgroundColor) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.conf.transparent = false))
              ],
              name: "背景色",
              block: ""
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.conf.transparent,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.conf.transparent) = $event)),
              name: "背景色(透過)"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString("透過"))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    (_ctx.showDetails)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 0,
          label: "絵文字の横幅"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Select, {
              modelValue: _ctx.conf.trimming,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.conf.trimming) = $event)),
                _ctx.refreshDefaultSettings
              ],
              name: "切り抜き",
              options: _ctx.TRIMMING_OPTIONS
            }, null, 8 /* PROPS */, ["modelValue", "options", "onUpdate:modelValue"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_CollapsibleSection, {
      label: "アス比",
      "default-open": false
    }, {
      default: _withCtx(() => [
        (_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_Fieldset, {
              key: 0,
              label: "アス比"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Slider, {
                  modelValue: _ctx.conf.targetAspect,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.conf.targetAspect) = $event)),
                  block: "",
                  nonzero: "",
                  step: 0.01,
                  marks: [1, _ctx.naturalAspect],
                  min: Math.min(0.2, _ctx.naturalAspect),
                  max: Math.max(5, _ctx.naturalAspect)
                }, null, 8 /* PROPS */, ["modelValue", "step", "marks", "min", "max"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_CollapsibleSection, {
      label: "アニメーション",
      "default-open": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Space, {
          vertical: "",
          full: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Select, {
              modelValue: _ctx.conf.animation,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.conf.animation) = $event)),
              name: "アニメーション",
              nullable: "",
              options: _ctx.animations
            }, null, 8 /* PROPS */, ["modelValue", "options"]),
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.conf.animationInvert,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.conf.animationInvert) = $event)),
              name: "逆再生"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString("逆再生"))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            (_ctx.showDetails)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 0,
                  label: "速度 (アニメ)"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      modelValue: _ctx.conf.speed,
                      "onUpdate:modelValue": [
                        _cache[7] || (_cache[7] = ($event: any) => ((_ctx.conf.speed) = $event)),
                        _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectSpeed($event)))
                      ],
                      name: "速度(アニメ)",
                      options: _ctx.SPEED_OPTIONS
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.showDetails)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 1,
                  label: "長さ (アニメ)"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Slider, {
                      modelValue: _ctx.conf.duration,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.conf.duration) = $event)),
                      block: "",
                      min: 0.1,
                      step: 0.1,
                      max: 2.0
                    }, null, 8 /* PROPS */, ["modelValue", "min", "step", "max"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.showDetails)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 2,
                  label: "イージング (アニメ)"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      modelValue: _ctx.conf.easing,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.conf.easing) = $event)),
                      name: "イージング",
                      options: _ctx.easings
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_CollapsibleSection, {
      label: "特殊効果とか",
      "default-open": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EffectBlock, {
          modelValue: _ctx.conf.webglEffects,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.conf.webglEffects) = $event)),
          effects: _ctx.webgleffects
        }, null, 8 /* PROPS */, ["modelValue", "effects"]),
        _createVNode(_component_EffectBlock, {
          modelValue: _ctx.conf.effects,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.conf.effects) = $event)),
          effects: _ctx.effects
        }, null, 8 /* PROPS */, ["modelValue", "effects"]),
        (_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_EffectBlock, {
              key: 0,
              modelValue: _ctx.conf.effects,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.conf.effects) = $event)),
              effects: _ctx.bgeffects
            }, null, 8 /* PROPS */, ["modelValue", "effects"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_EffectBlock, {
          modelValue: _ctx.conf.staticEffects,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.conf.staticEffects) = $event)),
          effects: _ctx.staticeffects
        }, null, 8 /* PROPS */, ["modelValue", "effects"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}